import { render, staticRenderFns } from "./SendEventConfirmationModal.vue?vue&type=template&id=e77e15d2&scoped=true&"
import script from "./SendEventConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./SendEventConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./SendEventConfirmationModal.vue?vue&type=style&index=0&id=e77e15d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77e15d2",
  null
  
)

export default component.exports